import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MessagesComponent } from '../messages/messages.component';

// Añade la palabra clave "export" a las interfaces
export interface Message {
  id: number;
  sender_id: number;
  content: string;
  date: string;
  created_at: string;
  is_mine: boolean;
  message_type: string;
  image_url: string | null;
}

export interface MessageGroup {
  date: string;
  messages: Message[];
}

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, MessagesComponent]
})
export class ContainerComponent implements OnInit {
  @Input() messageGroups: MessageGroup[] = [];
  @Output() showImage: EventEmitter<string> = new EventEmitter<string>();
  @Input() showAdditionalInfo: boolean = false; // Nuevo Input para mostrar información adicional

  constructor() { }

  ngOnInit() {}

  // Método para adaptar el mensaje al formato esperado por app-messages
  transformMessage(message: Message): any {
    return {
      type: message.is_mine ? 1 : 0, // Adaptando is_mine al formato anterior (type 1 o 0)
      text: message.content,
      date: message.created_at,
      // Mantenemos otros campos que puedan ser necesarios
      id: message.id,
      message_type: message.message_type,
      image_url: message.image_url
    };
  }

  forwardImage(url: string) {
    if (!url) return;
    this.showImage.emit(url);
  }
}
